import { useTranslation } from '@frontend/i18n';
import { titleCase } from '@frontend/string';
import { Heading } from '@frontend/design-system';
import { SectionInfo } from './SectionInfo';
import { insuranceDetailsContainerStyles, sectionInfoContainerStyles } from './styles';

type SubscriberDetailsProps = {
  subscriberFirstName?: string;
  subscriberLastName?: string;
  subscriberId?: string;
  subscriberDateOfBirth?: string;
};
export const SubscriberDetails = ({
  subscriberFirstName,
  subscriberLastName,
  subscriberDateOfBirth,
}: SubscriberDetailsProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  const patientName = `${titleCase(subscriberFirstName ?? '')} ${titleCase(subscriberLastName ?? '')}`.trim();

  return (
    <div css={insuranceDetailsContainerStyles}>
      <Heading level={3}>{t('Subscriber Details')}</Heading>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Name')} value={patientName || '-'} />
      </div>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Date of Birth')} value={subscriberDateOfBirth || '-'} />
      </div>
    </div>
  );
};
